import { render, staticRenderFns } from "./ConnectIcon.vue?vue&type=template&id=8474a27c"
import script from "./ConnectIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports